import { HttpClient, HttpParams } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@root/shared/service/translate.service';
import _ from 'lodash';
import { NzModalService } from 'ng-zorro-antd/modal';
import { NzMessageService } from 'ng-zorro-antd/message';

@Component({
  selector: 'host-deposit',
  templateUrl: './deposit.component.html',
  styleUrls: ['./deposit.component.scss']
})
export class DepositComponent implements OnInit {
  private readonly ListApi = '/api/deposit/list';
  private readonly DeducteApi = '/api/deposit/deduct';
  private readonly RefundApi = '/api/deposit/refund';
  tabType: 'paid' | 'wait_pay' | 'refunded' = 'paid';
  page = 1;
  pageSize = 50;
  total = 0;
  listOfDeposit = [];

  currentDeposit;

  constructor(
    private http: HttpClient,
    private modal: NzModalService,
    private msgSrv: NzMessageService,
    private t: TranslateService
  ) { }

  ngOnInit() {
    this.fetchDepositList();
  }

  fetchDepositList () {
    const { page, pageSize, tabType } = this;
    const obj = {
      page: `${page}`,
      page_size: `${pageSize}`,
      tab_type: tabType,
    };
    const query = new HttpParams({
      fromObject: obj
    });
    this.http.get(this.ListApi, { params: query }).subscribe(rst => {
      this.listOfDeposit = _.get(rst, 'data.list');
      this.total = _.get(rst, 'data.count');
      console.log('rst: ', rst);
    });
  }

  requestDeducte () {

    if (this.currentDeposit.waitDeductedDeposit < 0) {
      // return this.msgSrv.warning('不可输入负数');
      return this.msgSrv.warning(
        this.t.syncGet('deposit.list.deduct.toast.negative_waring')
      );
    }

    const params = {
      reservation_code: this.currentDeposit.code,
      amount: this.currentDeposit.waitDeductedDeposit
    };
    this.http.post(this.DeducteApi, params).subscribe((rst: any) => {
      if (rst.error_code === 0) {
        // this.msgSrv.success('押金已退');
        this.fetchDepositList();
      }
    });
  }

  requestRefund (code) {
    this.http.post(this.RefundApi, { reservation_code: code}).subscribe((rst: any) => {
      if (rst.error_code === 0) {
        // this.msgSrv.success('押金已退');
        this.msgSrv.success(
          this.t.syncGet('deposit.list.refund.toast.success')
        );
        this.fetchDepositList();
      }
    });
  }

  displayDeducteModal (tpl, data) {
    this.currentDeposit = data;
    this.currentDeposit.waitDeductedDeposit = data.deducted || 0;
    this.modal.create({
      // nzTitle: '扣押金',
      nzTitle: this.t.syncGet('deposit.list.deduct.modal.title'),
      nzContent: tpl,
      // nzOkText: '保存',
      nzOkText: this.t.syncGet('word.save'),
      nzOnOk: () => this.requestDeducte()
    });
  }

  displayRefundModal (data) {
    // this.currentDeposit = data;
    this.modal.confirm({
      // nzTitle: '确认立即退还押金？',
      nzTitle: this.t.syncGet('deposit.list.refund.modal.title'),
      // nzContent: `即将退还押金${data.pending_refund}`,
      nzContent: this.t.syncGet('deposit.list.refund.modal.content', {
        number: data.pending_refund
      }),
      nzOnOk: () => this.requestRefund(data.code)
    });
  }

  onPageChange () {
    this.fetchDepositList();
  }

}
